import { render, staticRenderFns } from "./RespMenu.vue?vue&type=template&id=6b0f3bac&scoped=true"
import script from "./RespMenu.vue?vue&type=script&lang=js"
export * from "./RespMenu.vue?vue&type=script&lang=js"
import style0 from "./RespMenu.vue?vue&type=style&index=0&id=6b0f3bac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0f3bac",
  null
  
)

export default component.exports